import { WebPlugin } from '@capacitor/core';
export class LiveActivityWeb extends WebPlugin {
    async startActivity(_options) {
        console.warn('LiveActivity: startActivity is only available on iOS.');
    }
    async updateActivity(_options) {
        console.warn('LiveActivity: updateActivity is only available on iOS.');
    }
    async endActivity(_options) {
        console.warn('LiveActivity: endActivity is only available on iOS.');
    }
    async isAvailable() {
        console.warn('LiveActivity: isAvailable is only available on iOS.');
        return false;
    }
    async isRunning(_options) {
        console.warn('LiveActivity: isRunning is only available on iOS.');
        return false;
    }
    async getCurrentActivity() {
        console.warn('LiveActivity: getCurrentActivity is only available on iOS.');
        return undefined;
    }
    async startObservingPushToStartToken() {
        console.warn('LiveActivity: startObservingPushToStartToken is only available on iOS.');
    }
    addListener(eventName, _listenerFunc) {
        console.warn(`LiveActivity: addListener('${eventName}') is only available on iOS.`);
        return Promise.resolve({
            remove: async () => {
                console.warn('LiveActivity: removeListener is a no-op on web.');
            },
        });
    }
}
//# sourceMappingURL=web.js.map